"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTransferWritableAccountAvailable = exports.isTransferAccountAvailable = exports.getTransactionBucket = exports.TransactionBucketEnum = exports.getLastReductionsChangeListLatestChange = exports.getSortedTransactionsByIds = exports.getTxnByMatchedTxnAndAccountId = exports.getCreatedTxnByClientAndAccountId = exports.filterDashboardCalendarTxnBasedOnPref = exports.filterCalendarTxnBasedOnPreferences = exports.isIncomeTxn = exports.getTransactionsByAccountIdsSelectors = exports.getTransactionsByAccountIdAndTxnId = exports.findTransactionInAccountOrByTxnId = exports.getTransactionsByTextFilter = exports.getTransactionsByFilter = exports.getTransactionsByFilterFn = exports.getTransactionsByIds = exports.getPopularCatsMonthlyAverage = exports.getMostPopularCatsByAccountId = exports.CategorySummary = exports.getTransactionById = exports.getTransactionsForAccountIds = exports.getRefundCompleteRelatedTxns = exports.getRefundCompleteTransactionsTotal = exports.getRefundCompleteTransactions = exports.getRefundActiveRelatedTxns = exports.getRefundActiveTransactionsTotal = exports.getRefundActiveTransactionsByAccountId = exports.getRefundActiveTransactions = exports.getAllUpcomingTransactions = exports.pastTransactions = exports.getTransactionsByAccountId = exports.getTransactionsForAccountIdSelectors = exports.getTransactionsById = exports.getTransactionsOfTypes = exports.txnTypesDefault = exports.TxnTypes = exports.getTransactionsByAccountIdRaw = exports.getAllTransactionsById = exports.getLastReductions = exports.getResourcesById = exports.getLastSyncDate = exports.getIsLoading = exports.getError = exports.getLoadPending = exports.getTransactionsStore = void 0;
const reselect_1 = require("reselect");
const re_reselect_1 = require("re-reselect");
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const core_1 = require("companion-app-components/flux/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const tags_1 = require("companion-app-components/flux/tags");
const categories_1 = require("companion-app-components/flux/categories");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const transactions_1 = require("companion-app-components/flux/transactions");
const selectors_1 = require("companion-app-components/flux/preferences/selectors");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const caches_1 = require("utils/auth/caches");
const utils_1 = require("utils/utils");
const utils_2 = require("./utils");
const getTransactionsStore = (state) => state[transactions_1.TRANSACTIONS_REDUCER_KEY];
exports.getTransactionsStore = getTransactionsStore;
const getLoadPending = (state) => (0, exports.getTransactionsStore)(state).loadPending;
exports.getLoadPending = getLoadPending;
const getError = (state) => (0, exports.getTransactionsStore)(state).error;
exports.getError = getError;
const getIsLoading = (state) => (0, exports.getTransactionsStore)(state).isLoading;
exports.getIsLoading = getIsLoading;
const getLastSyncDate = (state) => (0, exports.getTransactionsStore)(state).lastSyncDate;
exports.getLastSyncDate = getLastSyncDate;
const getResourcesById = (state) => (0, exports.getTransactionsStore)(state).resourcesById;
exports.getResourcesById = getResourcesById;
const getLastReductions = (state) => (0, exports.getTransactionsStore)(state).lastReductions;
exports.getLastReductions = getLastReductions;
exports.getAllTransactionsById = (0, reselect_1.createSelector)(exports.getResourcesById, accounts_1.accountsSelectors.getAccountsById, // temporary hack to drop any transactions that belongs to investment accounts TODO: remove
(state) => feature_flags_1.featureFlagsSelectors.getFeatureFlag(state, 'investmentTransactions'), (transactions, accounts, investmentTransactions) => transactions.filter((transaction) => { var _a; return investmentTransactions || !(((_a = accounts === null || accounts === void 0 ? void 0 : accounts.get(transaction.accountId)) === null || _a === void 0 ? void 0 : _a.type) === 'INVESTMENT'); }));
exports.getTransactionsByAccountIdRaw = (0, reselect_1.createSelector)(exports.getAllTransactionsById, (transactions) => transactions.groupBy((transaction) => transaction.accountId));
exports.TxnTypes = Object.freeze({
    GOALS: 1,
    REGULAR_TXNS: 2,
    UNACCEPTED_SCHEDULED_TXNS: 4,
    REFUND_VIRTUAL_TXN: 8,
    ALL: 0xffff,
});
exports.txnTypesDefault = exports.TxnTypes.REGULAR_TXNS | exports.TxnTypes.UNACCEPTED_SCHEDULED_TXNS;
const transactionOfTypes = (txn, goalAccountIds, txnTypes = exports.txnTypesDefault) => {
    if ((0, utils_2.isRefundVirtualTxn)(txn)) {
        return txnTypes & exports.TxnTypes.REFUND_VIRTUAL_TXN;
    }
    if ((0, utils_2.isGoalTxnInNonGoalAccount)(txn, goalAccountIds)) {
        return txnTypes & exports.TxnTypes.GOALS;
    }
    if ((0, utils_2.isUnacceptedScheduledTxn)(txn)) {
        return txnTypes & exports.TxnTypes.UNACCEPTED_SCHEDULED_TXNS;
    }
    return txnTypes & exports.TxnTypes.REGULAR_TXNS;
};
exports.getTransactionsOfTypes = (0, re_reselect_1.createCachedSelector)(exports.getAllTransactionsById, accounts_1.accountsSelectors.getGoalAccountIds, (state, txnTypes) => txnTypes || exports.txnTypesDefault, (transactionsById, goalAccountIds, txnTypes) => transactionsById.filter((transaction) => transactionOfTypes(transaction, goalAccountIds, txnTypes)))({
    keySelector: (_state, props) => (props === null || props === void 0 ? void 0 : props.txnTypes) || 'default',
});
// @ts-expect-error - FIXME: An argument for 'props' was not provided.
const getTransactionsById = (state) => (0, exports.getTransactionsOfTypes)(state);
exports.getTransactionsById = getTransactionsById;
// getTransactionsForAccountIdSelectors
//
// This selector returns a map of selectors that can then be used to get transactions
// filtered by txn-types for a specific account.
//
// We are using this level of indirection so that the returned transactions for each
// account will not be invalidated by the adding/removing of accounts or by changing
// transactional data in other accounts.
//
// The selectors returned by this method are not typical selectors. Instead of
// a state and props, the expected arguments are a map of transactions by
// account ID.
//
exports.getTransactionsForAccountIdSelectors = (0, re_reselect_1.createCachedSelector)(accounts_1.accountsSelectors.getAllAccountIds, accounts_1.accountsSelectors.getGoalAccountIds, (_state, props) => (props && props.txnTypes) || exports.txnTypesDefault, 
// eslint-disable-next-line no-spaced-func
(allAccountIds, goalAccountIds, txnTypes) => (0, immutable_1.Map)()
    .withMutations((map) => {
    allAccountIds.forEach((accountId) => {
        const selector = (0, reselect_1.createSelector)((transactionsByAccountId) => transactionsByAccountId.get(accountId), (txnsById) => {
            // handle special case of no transactions in account
            if (txnsById === undefined || txnsById.size === 0) {
                return (0, immutable_1.Map)();
            }
            const filteredTxnsById = txnsById.filter((txn) => transactionOfTypes(txn, goalAccountIds, txnTypes));
            return filteredTxnsById;
        });
        map.set(accountId, selector);
    });
}))({
    keySelector: (_state, props) => (props && props.txnTypes) || exports.txnTypesDefault,
    cacheObject: new re_reselect_1.FlatMapCache(),
});
exports.getTransactionsByAccountId = (0, re_reselect_1.createCachedSelector)(accounts_1.accountsSelectors.getAllAccountIds, exports.getTransactionsByAccountIdRaw, (state, props) => (0, exports.getTransactionsForAccountIdSelectors)(state, props), (allAccountIds, txnsByAccountId, txnsForAccountIdSelectors) => (0, immutable_1.Map)().withMutations((map) => {
    allAccountIds.forEach((accountId) => {
        const txnsForAccountIdSelector = txnsForAccountIdSelectors.get(accountId);
        if (txnsForAccountIdSelector) {
            map.set(accountId, txnsForAccountIdSelector(txnsByAccountId));
        }
    });
}))({
    keySelector: (_state, props) => (props && props.txnTypes) || exports.txnTypesDefault,
    cacheObject: new re_reselect_1.FlatMapCache(),
});
const sortStDueOn = (txn1, txn2) => 
// eslint-disable-next-line no-nested-ternary
(txn1.stDueOn || '') < (txn2.stDueOn || '') ? -1 : (txn1.stDueOn || '') > (txn2.stDueOn || '') ? 1 : 0;
exports.pastTransactions = (0, reselect_1.createSelector)(exports.getTransactionsByAccountId, (_, props) => props.id, (_, props) => { var _a; return (_a = props.transaction) === null || _a === void 0 ? void 0 : _a.accountId; }, (transactionsByAccountId, stModelId, accountId) => {
    const allTxn = transactionsByAccountId.get(accountId !== null && accountId !== void 0 ? accountId : '');
    return allTxn && allTxn.filter((d) => (0, utils_2.isAcceptedScheduledTxn)(d) && d.stModelId === stModelId).sort(sortStDueOn);
});
exports.getAllUpcomingTransactions = (0, reselect_1.createSelector)(exports.getTransactionsByAccountId, (_, props) => props, (transactionsByAccountId, schTxns) => {
    if (!transactionsByAccountId || transactionsByAccountId.isEmpty()) {
        return (0, immutable_1.Map)();
    }
    return (0, immutable_1.Map)().withMutations((mutableMap) => {
        schTxns.forEach(({ id, transaction: { accountId } }) => {
            const allTxn = transactionsByAccountId.get(accountId);
            const allUpcomingTxn = allTxn &&
                allTxn.filter((txn) => (0, utils_2.isUnacceptedScheduledTxn)(txn) && txn.stModelId === id).sort(sortStDueOn);
            if (allUpcomingTxn && !allUpcomingTxn.isEmpty()) {
                mutableMap.set(id, allUpcomingTxn);
            }
        });
    });
});
exports.getRefundActiveTransactions = (0, reselect_1.createSelector)((state) => (0, exports.getTransactionsOfTypes)(state, exports.txnTypesDefault | exports.TxnTypes.REFUND_VIRTUAL_TXN), (transactionsById) => transactionsById
    .filter((transaction) => {
    const refundState = (0, utils_2.getRefundState)(transaction);
    return refundState === utils_2.RefundState.EXPECTED || refundState === utils_2.RefundState.OVERDUE;
})
    .sortBy((transaction) => transaction.postedOn));
exports.getRefundActiveTransactionsByAccountId = (0, re_reselect_1.createCachedSelector)(exports.getRefundActiveTransactions, (state, accountId) => accountId, (refundActiveTransactions, accountId) => refundActiveTransactions.filter((transaction) => transaction.accountId === accountId))({
    keySelector: (state, accountId) => accountId || 'none',
    cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 10 }),
});
exports.getRefundActiveTransactionsTotal = (0, reselect_1.createSelector)(exports.getRefundActiveTransactions, (transactionsById) => transactionsById.reduce((total, transaction) => total + Number(transaction.amount), 0));
exports.getRefundActiveRelatedTxns = (0, re_reselect_1.createCachedSelector)(exports.getRefundActiveTransactions, (state, relatedTnxId) => relatedTnxId, (refundActiveTransactions, relatedTnxId) => refundActiveTransactions.filter((transaction) => { var _a; return ((_a = transaction.subtypeRelatedTxn) === null || _a === void 0 ? void 0 : _a.id) === relatedTnxId; }))({
    keySelector: (state, relatedTnxId) => relatedTnxId,
    cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 10 }),
});
exports.getRefundCompleteTransactions = (0, reselect_1.createSelector)((state) => (0, exports.getTransactionsOfTypes)(state, exports.txnTypesDefault | exports.TxnTypes.REFUND_VIRTUAL_TXN), (transactionsById) => transactionsById
    .filter((transaction) => {
    const refundState = (0, utils_2.getRefundState)(transaction);
    return refundState === utils_2.RefundState.COMPLETE || refundState === utils_2.RefundState.SHADOW;
})
    .sort((transaction1, transaction2) => { var _a; return (_a = transaction2.postedOn) === null || _a === void 0 ? void 0 : _a.localeCompare(transaction1.postedOn); }));
exports.getRefundCompleteTransactionsTotal = (0, reselect_1.createSelector)(exports.getRefundCompleteTransactions, (transactionsById) => transactionsById.reduce((total, transaction) => total + Number(transaction.amount), 0));
exports.getRefundCompleteRelatedTxns = (0, re_reselect_1.createCachedSelector)(exports.getRefundCompleteTransactions, (state, relatedTnxId) => relatedTnxId, (refundCompleteTransactions, relatedTnxId) => refundCompleteTransactions.filter((transaction) => { var _a; return ((_a = transaction.subtypeRelatedTxn) === null || _a === void 0 ? void 0 : _a.id) === relatedTnxId; }))({
    keySelector: (state, relatedTnxId) => relatedTnxId,
    cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 10 }),
});
exports.getTransactionsForAccountIds = (0, re_reselect_1.createCachedSelector)((_, props) => props.accountIds, exports.getTransactionsByAccountId, accounts_1.accountsSelectors.getAccountsById, (accountIds, transactionsByAccountId, accountsById) => {
    let accountIdsList = accountIds;
    if (!accountIds || (Array.isArray(accountIds) ? accountIds.length === 0 : accountIds.size === 0)) {
        accountIdsList = accountsById
            .filter((x) => x.type !== 'GOAL')
            .map((x) => x.id)
            .toList();
    }
    let returnTransactions = (0, immutable_1.Map)();
    accountIdsList === null || accountIdsList === void 0 ? void 0 : accountIdsList.forEach((id) => {
        // @ts-expect-error - FIXME: No overload matches this call.
        returnTransactions = returnTransactions.merge(transactionsByAccountId.get(id));
    });
    return returnTransactions;
})({
    keySelector: (state, props) => (props.accountIds ? props.accountIds.hashCode() : 'all'),
    cacheObject: new re_reselect_1.FlatMapCache(),
});
const getTransactionById = (state, id) => (0, exports.getTransactionsById)(state).get(id);
exports.getTransactionById = getTransactionById;
exports.CategorySummary = (0, immutable_1.Record)({
    count: 0,
    amount: 0,
    amountByMonth: null,
    coa: null,
    acctId: null,
    monthlyAverage: null,
});
exports.getMostPopularCatsByAccountId = (0, re_reselect_1.createCachedSelector)(exports.getTransactionsByAccountId, (_, props) => props && props.dateRange, (_, props) => props && props.sortByAmount, (txns, dateRange, sortByAmount) => {
    let catCount = (0, immutable_1.Map)();
    txns.forEach((acctTxns, acctId) => {
        acctTxns.forEach((txn) => {
            if (txn.coa && txn.coa.type === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY) {
                // ignore splits, transfers, and uncategorized
                // check date if it is supplied
                if (!dateRange || dateRange.contains(luxon_1.DateTime.fromISO(txn.postedOn))) {
                    const catRecord = catCount.get(txn.coa.id);
                    let amount = +txn.amount;
                    let count = 1;
                    const { month } = luxon_1.DateTime.fromISO(txn.postedOn);
                    let amountByMonth = (0, immutable_1.Map)().set(month, amount);
                    if (catRecord && catRecord.amountByMonth) {
                        amount = catRecord.amount + +txn.amount;
                        count = catRecord.count + 1;
                        amountByMonth = catRecord.amountByMonth.set(month, (catRecord.amountByMonth.get(month) || 0) + amount);
                    }
                    catCount = catCount.set(txn.coa.id, new exports.CategorySummary({
                        count,
                        amount,
                        amountByMonth,
                        coa: txn.coa,
                        acctId,
                    }));
                }
            }
        });
    });
    if (sortByAmount) {
        return catCount.toList().sort((a, b) => Math.abs(b.amount) - Math.abs(a.amount));
    }
    return catCount.toList().sort((a, b) => b.count - a.count);
})((state, props, selectorKey) => ((props && props.dateRange && props.dateRange.toISO()) || 'nodate') + (props && props.sortByAmount) + selectorKey, 
// @ts-expect-error - FIXME: Expected 1 arguments, but got 2.
{ cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 5 }) });
exports.getPopularCatsMonthlyAverage = (0, re_reselect_1.createCachedSelector)((state, props) => (0, exports.getMostPopularCatsByAccountId)(state, props), (popularCats) => {
    // must occur more than once
    let filteredCats = popularCats.filter((catg) => catg.amountByMonth.size > 1);
    // add in monthly average
    filteredCats = filteredCats.map((catg) => {
        var _a, _b;
        return catg.set('monthlyAverage', (catg.amount / ((_b = (_a = catg.amountByMonth) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0 ? _b : 1)).toFixed(0));
    });
    // sort by monthly average
    filteredCats = filteredCats.sort((catg1, catg2) => {
        var _a, _b, _c, _d;
        if (((_a = catg1.amountByMonth) === null || _a === void 0 ? void 0 : _a.size) === ((_b = catg2.amountByMonth) === null || _b === void 0 ? void 0 : _b.size)) {
            return Number(catg2.monthlyAverage || 0) - Number(catg1.monthlyAverage || 0);
        }
        return ((((_c = catg2.amountByMonth) === null || _c === void 0 ? void 0 : _c.size) || 1) * 5000 +
            Math.abs(catg2.amount) -
            ((((_d = catg1.amountByMonth) === null || _d === void 0 ? void 0 : _d.size) || 1) * 5000 + Math.abs(catg1.amount)));
    });
    return filteredCats;
})((_, props, selectorKey) => ((props && props.dateRange && props.dateRange.toISO()) || 'nodate') + (props && props.sortByAmount) + selectorKey, 
// @ts-expect-error - FIXME: Expected 1 arguments, but got 2.
{ cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 5 }) });
exports.getTransactionsByIds = (0, re_reselect_1.createCachedSelector)(exports.getTransactionsById, (_, ids) => ids, (transactionsById, ids) => transactionsById && transactionsById.filter((transaction) => ids && ids.includes(transaction.id)))((_, ids, selectorKey) => ids && ids.hashCode() + selectorKey, 
// @ts-expect-error - FIXME: Expected 1 arguments, but got 2.
{ cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 30 }) });
exports.getTransactionsByFilterFn = (0, re_reselect_1.createCachedSelector)((state, props) => (props === null || props === void 0 ? void 0 : props.transactions) || (0, exports.getTransactionsById)(state), (_, props) => props, (transactionsById, props) => transactionsById.filter((transaction) => !props || !props.filterFn || props.filterFn(transaction, props)))({
    keySelector: (_, props) => { var _a; return (_a = (props && props.filterFnGUID)) !== null && _a !== void 0 ? _a : ''; },
    cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 13 }),
});
exports.getTransactionsByFilter = (0, re_reselect_1.createCachedSelector)((state, filter) => (filter === null || filter === void 0 ? void 0 : filter.transactions) || (0, exports.getTransactionsById)(state), (_state, filter) => ({ obj: filter && filter.accountIds, deep: true }), (_state, filter) => ({ obj: filter && filter.accountIdsArray, deep: true }), (_state, filter) => ({ obj: filter && filter.startDate, deep: true }), (_state, filter) => ({ obj: filter && filter.endDate, deep: true }), (_state, filter) => ({ obj: filter && filter.payee, deep: false }), (_state, filter) => ({ obj: filter && filter.amountSign, deep: false }), (_state, filter) => ({ obj: filter && filter.rootCOAs, deep: true }), (_state, filter) => ({ obj: filter && filter.coas, deep: true }), (_state, filter) => ({ obj: filter && filter.isExcludedFromF2S, deep: false }), (_state, filter) => ({ obj: filter && filter.isScheduled, deep: false }), (_state, filter) => ({ obj: filter && filter.isScheduledPending, deep: false }), (transactionsById, { obj: accountIds }, { obj: accountIdsArray }, { obj: startLocalDate }, { obj: endLocalDate }, { obj: payee }, { obj: amountSign }, { obj: rootCOAs }, { obj: coas }, { obj: isExcludedFromF2S }, { obj: isScheduled }, { obj: isScheduledPending }) => transactionsById &&
    transactionsById.filter((transaction) => {
        let keepTransaction = true;
        keepTransaction = keepTransaction && payee !== undefined ? transaction.payee === payee : keepTransaction;
        keepTransaction =
            keepTransaction && amountSign !== undefined ? Math.sign(transaction.amount) === Math.sign(amountSign) : keepTransaction;
        keepTransaction =
            keepTransaction && isScheduled !== undefined ? Boolean(transaction.stModelId) === Boolean(isScheduled) : keepTransaction;
        keepTransaction =
            keepTransaction && isExcludedFromF2S !== undefined
                ? Boolean(transaction.isExcludedFromF2S) === Boolean(isExcludedFromF2S)
                : keepTransaction;
        keepTransaction =
            keepTransaction && accountIds && accountIds.size > 0 ? accountIds.has(transaction.accountId) : keepTransaction;
        keepTransaction =
            keepTransaction && accountIdsArray && accountIdsArray.size > 0
                ? accountIdsArray.includes(transaction.accountId)
                : keepTransaction;
        const postedOnLocalDate = keepTransaction && luxon_1.DateTime.fromISO(transaction.postedOn).toJSDate();
        keepTransaction = keepTransaction && startLocalDate ? postedOnLocalDate >= startLocalDate : keepTransaction;
        keepTransaction = keepTransaction && endLocalDate ? postedOnLocalDate <= endLocalDate : keepTransaction;
        keepTransaction =
            keepTransaction && rootCOAs && rootCOAs.size > 0
                ? Boolean(transaction.coa && rootCOAs.find((coa) => coa.type === transaction.coa.type && coa.id === transaction.coa.id))
                : keepTransaction;
        keepTransaction = coas && !coas.size ? false : keepTransaction;
        keepTransaction = keepTransaction && coas && coas.size > 0
            ? Boolean((transaction.coa && coas.find((coa) => { var _a, _b; return (coa === null || coa === void 0 ? void 0 : coa.type) === ((_a = transaction === null || transaction === void 0 ? void 0 : transaction.coa) === null || _a === void 0 ? void 0 : _a.type) && (coa === null || coa === void 0 ? void 0 : coa.id) === ((_b = transaction === null || transaction === void 0 ? void 0 : transaction.coa) === null || _b === void 0 ? void 0 : _b.id); })) ||
                (transaction.split && transaction.split.items && transaction.split.items.find((splitItem) => coas.find((coa) => coa.type === splitItem.coa.type && coa.id === splitItem.coa.id))))
            : keepTransaction;
        keepTransaction = keepTransaction && isScheduledPending !== undefined ?
            transaction.source === 'SCHEDULED_TRANSACTION_PENDING' : keepTransaction;
        return keepTransaction;
    }))({
    keySelector: (_, filter) => filter && `
    ${filter.isExcludedFromF2S}:${filter.isScheduled}:${filter.amountSign}:${filter.payee}
    :${JSON.stringify(filter.accountIdsArray)}:${filter.accountIds && filter.accountIds.hashCode()}
    :${filter.rootCOAs && filter.rootCOAs.hashCode()}:${filter.coas && filter.coas.hashCode && filter.coas.hashCode()}:${filter.startDate}:${filter.endDate}`,
    cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 13 }),
    selectorCreator: core_1.selectorsHelpers.createFlexEqualSelector,
});
const searchItemForText = (item, filterText, tagsById, filterNumber) => {
    let found = false;
    if (!found && item.memo && item.memo.toLowerCase().includes(filterText)) {
        found = true;
    }
    if (!found && filterNumber !== undefined && Math.round(Math.abs(item.amount)) === filterNumber) {
        found = true;
    }
    if (!found) {
        const coaString = chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(undefined, item.coa, true);
        if (coaString && (coaString === null || coaString === void 0 ? void 0 : coaString.toLowerCase().includes(filterText))) {
            found = true;
        }
    }
    if (!found && item.tags && tagsById) {
        if (
        // @ts-expect-error - FIXME: No overload matches this call.
        item.tags.find((tagRef) => {
            var _a;
            const tag = tagsById.get(tagRef.id);
            return tag && ((_a = tag.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(filterText));
        })) {
            found = true;
        }
    }
    return found;
};
exports.getTransactionsByTextFilter = (0, reselect_1.createSelector)((state, props) => props.transactions || (0, exports.getTransactionsForAccountIds)(state, props), // getTransactionsById(state, props),
accounts_1.accountsSelectors.getAccountsById, tags_1.tagsSelectors.getTags, (state, props) => props.filter, (transactionsById, accountsById, tagsById, filter) => {
    const filterLowerCase = filter && (filter === null || filter === void 0 ? void 0 : filter.toLowerCase());
    const filterDate = (0, utils_1.parseDateString)(filter);
    let filterNumber = filter ? Number(filter) : undefined;
    filterNumber = Number.isNaN(filterNumber) ? undefined : Math.round(Math.abs(filterNumber));
    const transactionsByIdFiltered = !filterLowerCase || !filterLowerCase.length ? transactionsById :
        transactionsById.filter((transaction) => {
            var _a, _b;
            let keepTransaction = false;
            if (!keepTransaction && transaction.payee && ((_a = transaction.payee) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(filterLowerCase))) {
                keepTransaction = true;
            }
            if (!keepTransaction) {
                const account = accountsById.get(transaction.accountId);
                if (account && ((_b = account.name) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(filterLowerCase))) {
                    keepTransaction = true;
                }
            }
            if (!keepTransaction && searchItemForText(transaction, filterLowerCase, tagsById, filterNumber)) {
                keepTransaction = true;
            }
            if (!keepTransaction && transaction.split && transaction.split.items) {
                if (transaction.split.items.find((item) => searchItemForText(item, filterLowerCase, tagsById))) {
                    keepTransaction = true;
                }
            }
            if (!keepTransaction && filterDate && filterDate === (0, utils_1.parseDateString)(transaction.postedOn)) {
                keepTransaction = true;
            }
            return keepTransaction;
        });
    return transactionsByIdFiltered;
});
exports.findTransactionInAccountOrByTxnId = (0, re_reselect_1.createCachedSelector)(exports.getTransactionsByAccountId, (state, props) => props.accountId, (state, props) => props.txnId, (transactionsByAccountId, accountId, txnId) => (0, utils_2.findTransaction)(transactionsByAccountId, txnId, accountId))((state, props) => `${props.accountId}_${props.txnId}`, 
// @ts-expect-error - FIXME: Expected 1 arguments, but got 2.
{ cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 200 }) });
const getTransactionsByAccountIdAndTxnId = (state, txnList) => txnList.map((txn) => (0, exports.findTransactionInAccountOrByTxnId)(state, {
    txnTypes: exports.txnTypesDefault | exports.TxnTypes.REFUND_VIRTUAL_TXN,
    accountId: txn.accountId,
    txnId: txn.id,
}));
exports.getTransactionsByAccountIdAndTxnId = getTransactionsByAccountIdAndTxnId;
// getTransactionsByAccountIdsSelectors
//
// We are using a selector based on accounts to return a map of selectors that
// can then be used to get transactions for a specific account. This map of
// selectors are stored in a global cache based on the current login.
//
// We are using this level of indirection and a global cache so that each account
// will have it's own selector for the retrieval of transactions which will not
// be invalided by the adding/removing of accounts, the updating of the account
// or changing transaction data within the account.
//
// The selectors returned by this method are not typical selectors. Instead of
// a state and props, the expected arguments are a map of transactions by
// account ID and options map. Currently the only supported option are
// sortBy and sortOrder.
//
exports.getTransactionsByAccountIdsSelectors = (0, reselect_1.createSelector)(accounts_1.accountsSelectors.getAccountsById, (accounts) => {
    let transactionsByAccountIdsSelector = (0, caches_1.getGlobalCache)('TRANSACTIONS_SELECTORS');
    if (!transactionsByAccountIdsSelector) {
        (0, caches_1.setGlobalCache)('TRANSACTIONS_SELECTORS', (transactionsByAccountIdsSelector = new Map()));
    }
    const activeAccountIds = [];
    accounts.forEach((account) => {
        activeAccountIds.push(account.id);
        // if selector doesn't exist, add it
        if (!transactionsByAccountIdsSelector.get(account.id)) {
            const selector = (0, reselect_1.createSelector)((transactionsByAccountId) => transactionsByAccountId.get(account.id), (transactionsByAccountId, options) => options, (txns) => {
                // was (txns, options) if you need the options
                // handle special case of no transactions in account
                if (txns === undefined || txns.size === 0) {
                    return (0, immutable_1.List)([]);
                }
                return (0, immutable_1.List)(txns.toList());
            });
            transactionsByAccountIdsSelector.set(account.id, selector);
        }
    });
    return (0, immutable_1.Map)(transactionsByAccountIdsSelector);
});
exports.isIncomeTxn = (0, reselect_1.createSelector)((state, txn) => txn, categories_1.categoriesSelectors.getIncomeCOAIds, transactions_1.transactionsUtils.isIncomeFromTxn);
exports.filterCalendarTxnBasedOnPreferences = (0, reselect_1.createSelector)((state, props) => props.txnList, (state) => (0, selectors_1.getSharedPreferencesByPath)(state, { group: 'dataset', path: ['webApp'] }).calendarTransaction, categories_1.categoriesSelectors.getIncomeCOAIds, accountGroupsSelectors_1.isEntityShareUser, (txnList, prefs, incomeCOAs, isEntityShareEnableUser) => {
    const visibleCalTxnTypes = [
        transactions_1.transactionsTypes.calTxnLabelTypes.more,
        ...(prefs.showTransactions ? [transactions_1.transactionsTypes.calTxnLabelTypes.normal] : []),
        ...(prefs.showScheduleTransactions && !isEntityShareEnableUser ? [
            transactions_1.transactionsTypes.calTxnLabelTypes.income,
            transactions_1.transactionsTypes.calTxnLabelTypes.expense,
            transactions_1.transactionsTypes.calTxnLabelTypes.overdue,
        ] : []),
    ];
    return txnList.filter((txn) => {
        const type = (0, utils_2.getCalendarTxnType)(txn, incomeCOAs);
        let filterAmount = true;
        if (prefs.exceedingAmount !== null) {
            filterAmount = Math.abs((0, utils_1.noNaN)(txn.amount)) >= Math.abs((0, utils_1.noNaN)(prefs.exceedingAmount));
        }
        return visibleCalTxnTypes.includes(type) && filterAmount && !(0, utils_2.isC2RTransaction)(txn);
    });
});
exports.filterDashboardCalendarTxnBasedOnPref = (0, reselect_1.createSelector)((state, props) => props.txnList, (state) => { var _a; return (_a = (0, selectors_1.getSharedPreferencesByPath)(state, { group: 'dataset', path: ['webApp'] }).calendarTransaction) === null || _a === void 0 ? void 0 : _a.dashboard; }, categories_1.categoriesSelectors.getIncomeCOAIds, (txnList, prefs, incomeCOAs) => {
    const visibleCalTxnTypes = [
        transactions_1.transactionsTypes.calTxnLabelTypes.more,
        ...((prefs === null || prefs === void 0 ? void 0 : prefs.showTransactions) ? [transactions_1.transactionsTypes.calTxnLabelTypes.normal] : []),
        ...((prefs === null || prefs === void 0 ? void 0 : prefs.showScheduleTransactions) ? [
            transactions_1.transactionsTypes.calTxnLabelTypes.income,
            transactions_1.transactionsTypes.calTxnLabelTypes.expense,
            transactions_1.transactionsTypes.calTxnLabelTypes.overdue,
        ] : []),
    ];
    return txnList === null || txnList === void 0 ? void 0 : txnList.filter((txn) => {
        const type = (0, utils_2.getCalendarTxnType)(txn, incomeCOAs);
        return visibleCalTxnTypes.includes(type) && !(0, utils_2.isC2RTransaction)(txn);
    });
});
// used for on-the-fly creation in transaction details
exports.getCreatedTxnByClientAndAccountId = (0, reselect_1.createSelector)((state, clientId) => clientId, (state, clientId, accountId) => (0, exports.getTransactionsForAccountIds)(state, { accountsIds: [accountId] }), (clientId, txns) => {
    if (clientId) {
        return txns.find((item) => item.clientId === clientId && item.clientId !== item.id);
    }
    return undefined;
});
exports.getTxnByMatchedTxnAndAccountId = (0, reselect_1.createSelector)((state, matchedTxnId) => matchedTxnId, (state, _matchedTxnId, accountId) => (0, exports.getTransactionsForAccountIds)(state, { accountsIds: [accountId] }), (matchedTxnId, txns) => {
    if (matchedTxnId) {
        return txns.find((item) => { var _a; return ((_a = item.matchedTxn) === null || _a === void 0 ? void 0 : _a.id) === matchedTxnId; });
    }
    return undefined;
});
exports.getSortedTransactionsByIds = (0, re_reselect_1.createCachedSelector)(exports.getTransactionsByIds, (txns) => txns === null || txns === void 0 ? void 0 : txns.sort((a, b) => {
    if (luxon_1.DateTime.fromISO(a.postedOn) >= luxon_1.DateTime.fromISO(b.postedOn)) {
        return 1;
    }
    return -1;
}))((_, ids, selectorKey) => ids && ids.hashCode() + selectorKey, 
// @ts-expect-error - FIXME: Expected 1 arguments, but got 2 ts(2554)
{ cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 20 }) });
exports.getLastReductionsChangeListLatestChange = (0, reselect_1.createSelector)(exports.getLastReductions, (lastReductions) => { var _a; return (_a = lastReductions === null || lastReductions === void 0 ? void 0 : lastReductions.get('changeList')) === null || _a === void 0 ? void 0 : _a.last(); });
exports.TransactionBucketEnum = Object.freeze({
    EXPENSE: 'EXPENSE',
    INCOME: 'INCOME',
    TRANSFER: 'TRANSFER',
});
exports.getTransactionBucket = (0, re_reselect_1.createCachedSelector)((state, transaction) => transactions_1.transactionsUtils.isSplitTxn(transaction), (state, transaction) => transaction.coa && transaction.coa.type === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY
    ? categories_1.categoriesSelectors.isIncomeCat(state, transaction.coa.id)
    : undefined, (state, transaction) => transaction.coa, (state, transaction) => transaction.amount, (isSplit, isIncome, coa, amount) => {
    let coaType;
    if (isSplit) {
        coaType = amount > 0 ? exports.TransactionBucketEnum.INCOME : exports.TransactionBucketEnum.EXPENSE;
    }
    else {
        switch (coa && coa.type) {
            case 'CATEGORY':
                coaType = isIncome ? exports.TransactionBucketEnum.INCOME : exports.TransactionBucketEnum.EXPENSE;
                break;
            case 'ACCOUNT':
            case 'BALANCE_ADJUSTMENT':
                coaType = exports.TransactionBucketEnum.TRANSFER;
                break;
            case 'UNCATEGORIZED':
                coaType = exports.TransactionBucketEnum.EXPENSE;
                break;
            default:
                coaType = exports.TransactionBucketEnum.EXPENSE;
                break;
        }
    }
    return coaType;
})((state, transaction) => `${transactions_1.transactionsUtils.isSplitTxn(transaction)}:${transaction.coa && transaction.coa.type}:${transaction.coa && transaction.coa.id}:${transaction.amount}`, 
// @ts-expect-error - FIXME: Expected 1 arguments, but got 2 ts(2554)
{ cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 10 }) });
const createTransferAccountAvailableSelector = (accountsSelector) => (0, reselect_1.createSelector)([
    accountGroupsSelectors_1.isAccountGroupEnabled,
    accountsSelector,
    (_, txn) => txn,
], (isEntityGroupEnabledUser, accountsById, txn) => {
    // if not a transfer or not an entity-shared user, it's available
    if (!transactions_1.transactionsUtils.isTransferTxn(txn) || !isEntityGroupEnabledUser) {
        return true;
    }
    const coaIds = (() => {
        var _a, _b;
        if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
            const splitItems = (_b = (_a = txn === null || txn === void 0 ? void 0 : txn.split) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
            return splitItems
                .map((split) => split === null || split === void 0 ? void 0 : split.coa)
                .filter((coa) => !!coa && coa.type === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.ACCOUNT)
                .map((coa) => coa.id);
        }
        const coa = txn === null || txn === void 0 ? void 0 : txn.coa;
        if ((coa === null || coa === void 0 ? void 0 : coa.type) === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.ACCOUNT && coa.id) {
            return [coa.id];
        }
        return [];
    })();
    if (coaIds.length === 0) {
        return false;
    }
    return coaIds.some((id) => Boolean(accountsById.get(id)));
});
exports.isTransferAccountAvailable = createTransferAccountAvailableSelector(accounts_1.accountsSelectors.getEntityShareAccountsById);
exports.isTransferWritableAccountAvailable = createTransferAccountAvailableSelector(accounts_1.accountsSelectors.getWriteEntityShareAccountsById);
